import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import MessageAlertLevel from '../MessageAlertLevel';

function DesktopVersionsList({ licenses, onOpenFormClick }) {
    const { t } = useTranslation();
    const [licenseKey, setLicenseKey] = useState(null);

    const handleRowClick = useCallback(clickedKey => {
        setLicenseKey(prevKey => (prevKey === clickedKey ? '' : clickedKey));
    }, []);

    return (
        <table className="table table-stripe table-hover table-active">
            <thead>
            <tr>
                <th>Product</th>
                <th style={{ width: 200 }}>{t('desktopversionslist.version')}</th>
                <th style={{ width: 190 }}></th>
                <th style={{ width: 190 }}></th>
            </tr>
            </thead>
            <tbody>
            {licenses.map((license, index) => (
                <React.Fragment key={license.licenseKey || index}>
                    <tr
                        className={licenseKey === license.licenseKey ? 'mainLicense active' : 'mainLicense'}
                        onClick={() => handleRowClick(license.licenseKey)}
                    >
                        <td><a>{license.productName}</a></td>
                        <td>
                            {license.version
                                ? license.version
                                : <MessageAlertLevel message={t('desktopversionslist.contactcustomeradministration')} />
                            }
                        </td>
                        <td className="text-center">{t('desktopversionslist.currentversion')}</td>
                        <td className="text-center">
                            <button
                                className="btn btn-default btn-sm"
                                disabled={!license.version}
                                onClick={e => {
                                    e.stopPropagation(); // prevent row toggle
                                    onOpenFormClick(license.applicationNo, license.version, license.licenseKey);
                                }}
                            >
                                <span className="vismaicon vismaicon-sm vismaicon-email" title="Send Key" /> {t('desktopversionslist.sendkey')}
                            </button>
                        </td>
                    </tr>
                    {license.productVersions.map((item, index2) => (
                        <tr
                            key={item.id}
                            className={licenseKey === license.licenseKey ? 'subLicenses' : 'subLicenses hidden'}
                        >
                            <td />
                            <td>{item.version}</td>
                            <td />
                            <td />
                        </tr>
                    ))}
                </React.Fragment>
            ))}
            </tbody>
        </table>
    );
}

export default DesktopVersionsList;